<template>
    <div class="workOrder">
        <h1>工程工单信息详情</h1>
        <el-table :data="propertiesViceList" border>
            <el-table-column prop="secondClassifyName" align="center" label="字段名">
                <template slot-scope="scope">{{ scope.row.title }}</template>
            </el-table-column>
            <el-table-column prop="secondClassifyName" align="center" label="值">
                <template slot-scope="scope">
                    <template v-if="scope.row.dataType != 'img'">{{
                        scope.row.value
                        }}</template>
                    <template v-if="scope.row.dataType == 'img'">
                        <viewer :images="formmaterImageNew(scope.row.value)">
                            <img v-for="src in formmaterImageNew(scope.row.value)" :src="src" :key="src" width="20" />
                        </viewer>
                    </template>
                </template>
            </el-table-column>
        </el-table>
        <el-table :data="serviceFee" v-if="showBottom">
            <el-table-column prop="secondClassifyName" align="center" border>
                <template slot-scope="scope">{{ scope.row.key }}</template>
            </el-table-column>
            <el-table-column prop="secondClassifyName" align="center" border>
                <template slot-scope="scope">{{ scope.row.value }}</template>
            </el-table-column>
        </el-table>
    </div>
</template>
<script>
import { mapGetters } from "vuex";
import { serviceListing } from "@/api/work/serviceOrder";
export default {
    name: "projectService",
    data() {
        return {
            propertiesViceList: [],
            showBottom: false,
        };
    },
    created() {
        this.serviceListing(this.$route.query.id);
    },
    watch: {},
    mounted() { },
    components: {},
    computed: {
        ...mapGetters(["permission"]),
    },
    props: [],
    methods: {
        //获取工单列表
        serviceListing(id) {
            this.showBottom = false;
            serviceListing(id).then((res) => {
                this.workOrderData = [];
                this.serviceFee = [];
                this.propertiesViceList = [];
                let data = JSON.parse(res.data);
                this.workOrderData = data;
                this.propertiesViceList = data.propertiesViceList;
                if (data.serviceFee.servicePrice) {
                    let obj = { key: "收费标准", value: data.serviceFee.servicePrice };
                    this.serviceFee.push(obj);
                }
                if (data.serviceFee.otherExpensesAmount) {
                    let obj1 = {
                        key: "其他费用",
                        value: data.serviceFee.otherExpensesAmount,
                    };
                    this.serviceFee.push(obj1);
                }
                if (data.serviceFee.otherChargesDesc) {
                    let obj2 = {
                        key: "其他费用备注",
                        value: data.serviceFee.otherChargesDesc,
                    };
                    this.serviceFee.push(obj2);
                }

                let obj3 = { key: "总费用", value: data.serviceFee.servicePriceTotal };
                this.serviceFee.push(obj3);
                if (data.serviceFee.servicePriceTotal != null) {
                    this.showBottom = true;
                }
            });
        },
        formmaterImageNew(row) {
            let str = new Array();
            // JSON.stringify(row);
            if (row != null) {
                let picArray = row.split(",");
                // let picArray = row;
                for (let i = 0; i < picArray.length; i++) {
                    if (picArray[i] != 'null') {
                        str.push(picArray[i]);
                    }

                }
            }
            return str;
        },
    },
};
</script>
<style scoped>
.workOrder {
    padding: 20px;
    text-align: center;
}
</style>